<script setup>
import { useDisplay } from 'vuetify';
const { smAndDown, lgAndDown } = useDisplay();
</script>

<template>
    <div 
        class="flex items-center"
        :class="{ 'mt-5': smAndDown }"
    >
        <a
            href="https://www.youtube.com/@KazMunaiGaspress" 
            target="__blank"
            class="rounded-full bg-[#00000014] flex items-center justify-center mr-4"
            :class="
                smAndDown ?   'h-10 w-10' 
                :   lgAndDown   ?   'h-6 w-6'
                :   'h-[52px] w-[52px]'
            "
        >
            <img 
                src="/images/social-youtube.svg" 
                :class="
                    smAndDown ?   'h-5 w-5' 
                    :   lgAndDown   ?   'h-4 w-4'    
                    :   'h-7 w-7'
                "
            />
        </a>
        <a
            href="https://t.me/kmgpress" 
            target="__blank"
            class="rounded-full bg-[#00000014] flex items-center justify-center mr-4"
            :class="
                smAndDown ?   'h-10 w-10' 
                :   lgAndDown   ?   'h-6 w-6'
                :   'h-[52px] w-[52px]'
            "
        >
            <img 
                src="/images/social-telegram.svg" 
                :class="
                    smAndDown ?   'h-5 w-5' 
                    :   lgAndDown   ?   'h-4 w-4'    
                    :   'h-7 w-7'
                "
            />
        </a>
        <a
            href="https://www.instagram.com/kazmunaygaspress" 
            targer="__blank"
            class="rounded-full bg-[#00000014] flex items-center justify-center mr-4"
            :class="
                smAndDown ?   'h-10 w-10' 
                :   lgAndDown   ?   'h-6 w-6'
                :   'h-[52px] w-[52px]'
            "
        >
            <img 
                src="/images/social-instagram.svg" 
                :class="
                    smAndDown ?   'h-4 w-4' 
                    :   lgAndDown   ?   'h-3 w-3'    
                    :   'h-6 w-6'
                "
            />
        </a>
    </div>
</template>